<template>
    <div>
        <el-select v-model="selected_bank" id="bank_selector">
            <el-option v-for="item in banks" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
        </el-select>
        <el-upload drag :data="upload_options" :show-file-list="false" :on-success="success_upload" :action="bankStatementsUploadLocation">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
        </el-upload>
    </div>
</template>
<script>
export default {
    name: 'import_transactions',
    data: () => ({
        banks: [{
            value: 'privat',
            label: 'Приватбанк'
        }, {
            value: 'monobank',
            label: 'Монобанк'
        }, {
            value: 'monobank_api',
            label: 'Монобанк API'
        }
        ],
        selected_bank: 'privat',
        bankStatementsUploadLocation: 'http://localhost:8000/api/upload_bank_statements/'
    }),
    computed: {
        upload_options: function() {
            return { 'bank': this.selected_bank }
        }
    },
    methods: {
        success_upload: function(response) {
            this.$message({
                message: `Виписку успішно імпортовано! Створено ${response.imported_transactions} транзакцій`,
                type: 'success',
                duration: 2000
            });
        }
    }

}
</script>
<style>
.el-select {
    margin-bottom: 10px;
}
</style>